/**
 * Action Trigger Card Component
 *
 * Selection card used in the Create Automation Wizard for both
 * action selection and trigger selection steps.
 */

import { FC } from 'react';
import { Card, CardActionArea, CardContent } from 'src/components/Card';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

interface ActionTriggerCardProps {
  title: string;
  description?: string;
  onClick?: () => void;
}

export const ActionTriggerCard: FC<ActionTriggerCardProps> = ({
  title,
  description,
  onClick,
}) => (
  <Card
    elevation={0}
    sx={{
      height: '100%',
      border: '1px solid',
      borderColor: 'divider',
      transition: 'all 0.15s ease-in-out',
      '&:hover': {
        borderColor: 'primary.main',
        bgcolor: 'action.hover',
      },
    }}
  >
    <CardActionArea
      onClick={onClick}
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}
    >
      <CardContent sx={{ p: 2, width: '100%' }}>
        <Stack spacing={0.5}>
          <Typography variant="subtitle1">
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </CardActionArea>
  </Card>
);

